import React from 'react'
import { Link } from 'react-router-dom'
import EditIcon from 'Assets/Images/icons/edit'

export const LinkEditUnstyled = props => (
  <Link
    className={`${props.className} link-edit`}
    to={props.to}
    cypress_id={props.cypress_id}
  >
    <EditIcon />
    {props.label}
  </Link>
)
